import * as svg from "../../../assets/time-fast-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const TimeFastIcon = iconBuilder(svg, "TimeFastIcon", "0 0 14 15");
